import styled from '@emotion/styled/macro';

export const TransactionDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 5px;
`;
